export default __webpack_public_path__ + "static/media/AAVE-USDT.a741850f.svg";